// Metas do mês da analítica de ligações (PATCH voip_analytics/targets).
// `kpi` é a chave que o GET devolve em kpis; `field` é o atributo que o
// PATCH aceita. Valores em dinheiro trafegam em centavos e a tela edita em
// reais.
export const TARGET_FIELDS = [
  { kpi: 'leads_criados', field: 'leads_target', key: 'LEADS' },
  { kpi: 'agendados', field: 'agendamentos_target', key: 'SCHEDULED' },
  { kpi: 'comparecimentos', field: 'comparecimentos_target', key: 'ATTENDED' },
  { kpi: 'fechamentos', field: 'fechamentos_target', key: 'CLOSED' },
  { kpi: 'ticket_medio', field: 'ticket_medio_cents', key: 'AVG_TICKET', money: true },
  { kpi: 'valor_vendas', field: 'valor_vendas_cents', key: 'SALES_VALUE', money: true },
];

export const hasAnyTarget = kpis =>
  Object.values(kpis || {}).some(kpi => Number(kpi?.target) > 0);

export const targetDraftFromKpis = (kpis = {}) =>
  TARGET_FIELDS.reduce((draft, { kpi, field, money }) => {
    const target = Number(kpis?.[kpi]?.target) || 0;
    draft[field] = money ? String(target / 100) : String(target);
    return draft;
  }, {});

// Aceita o formato brasileiro (1.234,50) e o do campo numérico (1234.5).
const toNumber = value => {
  let normalized = String(value ?? '').trim().replace(/\s/g, '');
  if (normalized.includes(',')) {
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  }
  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const targetPayloadFromDraft = (draft = {}) =>
  TARGET_FIELDS.reduce((payload, { field, money }) => {
    const value = toNumber(draft[field]);
    payload[field] = money ? Math.round(value * 100) : Math.round(value);
    return payload;
  }, {});
